﻿'use strict'

import * as Entities_Language from './entities/language';
import config from './config';

var Language = {
    getDefault: function () {
        window.tmp = {};

        var events4us_userCultureName = this.getCookie('events4us_userCultureName');

        if (events4us_userCultureName && events4us_userCultureName != "null") {
            window.event4us.config.cultureName = events4us_userCultureName;
        }
        else {
            //var userLang = navigator.language || navigator.userLanguage;  not disabled

            var userLang = window.navigator.userLanguage;
            if (userLang == undefined) userLang = window.navigator.language;
            window.event4us.config.cultureName = this.getLanguageCodeFromBrowser(userLang);

            //window.event4us.config.cultureName = 'da-DK';
            events4us_userCultureName = window.event4us.config.cultureName;
        }

        this.createCookie("events4us_userCultureName", events4us_userCultureName, 10000);

    },
    createCookie: function (name, value, days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }
        else {
            expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    },
    getCookie: function getCookie(name) {
        var re = new RegExp(name + "=([^;]+)");
        var value = re.exec(document.cookie);
        return (value != null) ? unescape(value[1]) : null;
    },
    userLanguageChange: function (language) {
        var self = this;

        var callback = function () {
            /*var events4us_userCultureName = '';
            switch (language) {
                case 'DK': events4us_userCultureName = 'da-DK'; break;
                case 'GB': events4us_userCultureName = 'en-GB'; break;
                case 'DE': events4us_userCultureName = 'de-DE'; break;
            }*/
            //self.createCookie("events4us_userCultureName", events4us_userCultureName, 10000);
            self.createCookie("events4us_userCultureName", language, 10000);

            location.reload();
        }

        window.app.router.checkHasChanged(callback);
    },
    getLanguageCodeFromBrowser: function (language) {
        switch (language) {
            case 'en': return "en-GB"; break;
            case 'EN': return "en-GB"; break;
            case 'en-gb': return "en-GB"; break;
            case 'en-GB': return "en-GB"; break;
            case 'EN-GB': return "en-GB"; break;
            case 'da': return "da-DK"; break;
            case 'DA': return "da-DK"; break;
            case 'da-dk': return "da-DK"; break;
            case 'da-DK': return "da-DK"; break;
            case 'DA-DK': return "da-DK"; break;
            default: return ("en-GB"); break;
        };
        return "da-DK";
    },
    getLanguageFromCodeCultureName: function (language) {
        switch (language) {
            case 'en-GB': return "GB"; break;
            case 'da-DK': return "DK"; break;
            default: return ("GB"); break;
        };
        return "DK";
    },
    getCurrencyFromCultureName: function (cultureName) {
        switch (cultureName) {
            case 'en-GB': return "GBP"; break;
            case 'da-DK': return "Kr"; break;
            default: return ("GBP"); break;
        };
        return "Kr";
    },
    getLanguage_bootstrap_datePicker: function (cultureName) {
        var language_bootstrap_datePicker = '';
        switch (cultureName) {
            case 'da-DK': language_bootstrap_datePicker = 'da'; break;
            default: language_bootstrap_datePicker = 'en-GB'; break;
        }

        return language_bootstrap_datePicker;
    },
    getLanguageDataTables: function () {
        var language = new Array;

        language = {
            'sProcessing': resources.X100004,
            'sLengthMenu': resources.X100005,
            'sZeroRecords': resources.X100006,
            'sInfo': resources.X100007,
            'sInfoEmpty': resources.X100008,
            'sInfoFiltered': resources.X100009,
            'sInfoPostFix': resources.X1000010,
            'sSearch': " " + resources.X100011,
            'sUrl': resources.X100012,
            'oPaginate': {
                'sFirst': '&lsaquo;',
                'sLast': '&rsaquo;',
                'sNext': '&raquo;',
                'sPrevious': '&laquo;'
            },
            'oAria': {
                'sSortAscending': resources.X100014,
                'sSortDescending': resources.X100015
            },
            'sRefresh': resources.X100013,
            "lengthMenu": ' Vis <select>' +
                '<option value="1">01</option>' +
                '<option value="2">02</option>' +
                '<option value="3">03</option>' +
                '<option value="4">04</option>' +
                '<option value="5">05</option>' +
                '<option value="6">06</option>' +
                '<option value="7">07</option>' +
                '<option value="8">08</option>' +
                '<option value="9">09</option>' +
                '<option value="10">10</option>' +
                '<option value="11">11</option>' +
                '<option value="12">12</option>' +
                '<option value="13">13</option>' +
                '<option value="14">14</option>' +
                '<option value="15">15</option>' +
                '<option value="16">16</option>' +
                '<option value="17">17</option>' +
                '<option value="18">18</option>' +
                '<option value="19">19</option>' +
                '<option value="20">20</option>' +
                '<option value="21">21</option>' +
                '<option value="22">22</option>' +
                '<option value="23">23</option>' +
                '<option value="24">24</option>' +
                '<option value="25">25</option>' +
                '<option value="26">26</option>' +
                '<option value="27">27</option>' +
                '<option value="28">28</option>' +
                '<option value="29">29</option>' +
                '<option value="30">30</option>' +
                '<option value="31">31</option>' +
                '<option value="32">32</option>' +
                '<option value="33">33</option>' +
                '<option value="34">34</option>' +
                '<option value="35">35</option>' +
                '<option value="36">36</option>' +
                '<option value="37">37</option>' +
                '<option value="38">38</option>' +
                '<option value="39">39</option>' +
                '</select>'
        }

        return language;
    },
    //Remember to save it with UTF-8 from notepad
    setLanguage: function (cultureName, callback) {
        var entities = new Entities_Language.Collection();

        $.when(

            entities.fetch({
                parseField: cultureName,
                wait: true,
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            })
        ).done(function () {
            callback(entities.models);
        });
    },
    setLanguageFromFile: function (cultureName, filename, callback) {
        var entities = new Entities_Language.Collection();

        $.when(
            entities.fetch({
                parseField: cultureName,
                filename: filename,
                wait: true,
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            })
        ).done(function () {
            callback(entities.models);
        });
    }
};

export default Language;